export default "__VITE_ASSET__7cc1d7df__"